import ElectronicClock from "./components/ElectronicClock/ElectronicClock";

type BroadcastCommandsProps = {
  deviceId: string;
};

const BroadcastCommands = ({ deviceId }: BroadcastCommandsProps) => {
  return <ElectronicClock deviceId={deviceId} />;
};

export default BroadcastCommands;
